var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isComponentType && _vm.totalRootChildren > 1)?_c('div',{staticClass:"components-root-tag-warning"},[_vm._v(" Components must have a single root tag. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }